import {
    Button,
    Col,
    Dropdown,
    Input,
    Menu,
    message,
    Modal,
    Row,
    Tag,
    Table,
    Card,
    Upload,
} from 'antd';
import axios from 'axios';
import Can from '../../components/Can';
import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { url } from '../../constant/url';
import {
    CheckCircleOutlined,
    DeleteOutlined,
    PlusOutlined,
    ImportOutlined,
    ExportOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    EditOutlined,
} from '@ant-design/icons';
import fileDownload from 'js-file-download';
import moment from 'moment';
import _ from 'underscore';

function Ng(history) {
    const columns = [
        {
            title: 'Department',
            dataIndex: 'plan_name',
            key: 'plan_name',
        },

        {
            title: 'Main Process Name',
            dataIndex: 'main_processes',
            key: 'main_processes',
            render: (_, record) => record.main_process ?? record.main_processes,
            sorter: false,
        },
        {
            title: 'Ng Parent Name ',
            dataIndex: 'name',
            key: 'name',
            sorter: false,
        },

        {
            title: '',
            dataIndex: '_id',
            key: 'id',
            sorter: false,
            fixed: 'right',
            width: 50,
            render: (id) => {
                return (
                    <>
                        <Dropdown
                            className="pointer"
                            overlay={
                                <Menu>
                                    {/* <Menu.Item key="1">
                    <span onClick={() => handleApprove(id)}>
                      <CheckCircleOutlined /> Approve
                    </span>
                  </Menu.Item>
                  <Menu.Item key="2">
                    <span onClick={() => handleReject(id)}>
                      <CloseCircleOutlined />
                      Reject
                    </span>
                  </Menu.Item> */}
                                    <Menu.Item key="3">
                                        <Link to={`/master-ng/edit/${id}`}>
                                            {/* <i className="mdi mdi-pencil mr-5" /> Edit */}
                                            <EditOutlined /> Edit
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="4">
                                        <span onClick={() => handleDelete(id)}>
                                            {/* <i className="mdi mdi-delete mr-5" /> */}
                                            <DeleteOutlined />
                                            Delete
                                        </span>
                                    </Menu.Item>
                                </Menu>
                            }
                            trigger={['click']}
                        >
                            <span
                                className="pointer"
                                onClick={(e) => e.preventDefault()}
                            >
                                <i className="mdi mdi-dots-vertical" />
                            </span>
                        </Dropdown>
                    </>
                );
            },
        },
    ];

    const [total, setTotal] = useState([]);
    const [totalDetail, setTotalDetail] = useState([]);
    const [page, setPage] = useState(1);
    const [perpage, setPerpage] = useState(10);
    const [sort, setSort] = useState({
        sort: 'created_at',
        order: 'ascend',
    });

    const [sortDetail, setSortDetail] = useState({
        sort: 'updated_at',
        order: 'descend',
    });

    const [loading, setLoading] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [spCardDetail, setSpCardDetail] = useState([]);
    const [pageDetail, setPageDetail] = useState(1);
    const [selectedId, setSelectedId] = useState('');
    const [perPageDetail, setPerPageDetail] = useState(10);
    const [rowDetails, setRowDetails] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [spCardSelected, setSpCardSelected] = useState(null);

    const [keywordDetails, setKeywordDetails] = useState('');

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [error, setError] = useState(null);
    const [operator, setOperator] = useState([]);

    const [data, setData] = useState({
        file: null,
    });

    const handleRemove = () => {
        setData({
            ...data,
            file: null,
        });
    };

    useEffect(() => {
        getData();
    }, [keyword, page, perpage, sort]);

    useEffect(() => {
        if (selectedId) {
            getSpCardDetail();
        }
    }, [keywordDetails, sortDetail, pageDetail, perPageDetail]);
    const getData = () => {
        setLoading(true);
        axios
            .get(`${url}/master-ng`, {
                params: {
                    keyword,
                    columns: ['name', 'plan_id', 'plan_name', 'line_processes'],
                    perpage: perpage,
                    page,
                    sort: sort.sort,
                    order: sort.order,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then((res) => {
                setOperator(res.data);
                setTotal(res.data.total);
            })
            .catch((err) => {
                if (err.response) {
                    message.error(err.response.data.message);
                    if (err.response.status === 401) {
                        localStorage.removeItem('token');
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleDelete = (id) => {
        Modal.confirm({
            title: 'Are you sure ?',
            content: (
                <div>
                    <p>Deleted data cannot be restored</p>
                </div>
            ),
            okText: 'Delete',
            showCancel: true,
            onCancel: () => {
                return;
            },
            cancelText: 'Cancel',
            confirmLoading: loading,
            onOk: async () => {
                confirmDelete(id);
            },
        });
    };

    const confirmDelete = (id) => {
        setLoading(true);
        axios
            .delete(`${url}/master-ng/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then((res) => {
                message.success(res.data.message);
                getData();
            })
            .catch((err) => {
                if (err.response) {
                    message.error(err.response.data.message);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage(pagination.current);
        setPerpage(pagination.pageSize);
        setSort({
            sort: sorter.field,
            order: sorter.order,
        });
    };

    const downloadTemplate = () => {
        axios
            .get(`${url}/master-ng/export/download`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                responseType: 'blob',
            })
            .then((res) => {
                fileDownload(res.data, `Export master-ng.xlsx`);
            })
            .catch((err) => {
                if (err.response) {
                    message.error(err.response.data.message);
                }
            });
    };

    const handleBeforeUpload = (files) => {
        setData({
            ...data,
            file: files,
        });

        return false;
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setData({
            ...data,
            file: null,
        });
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const onSaveData = () => {
        setLoading(true);

        let fd = new FormData();

        fd.append('file', data.file);

        axios
            .post(`${url}/master-ng/ng/import`, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then((res) => {
                message.success(res.data.message);
                getData();
                closeModal();
            })
            .catch((err) => {
                if (err.response) {
                    message.error(err.response.data.message);
                    if (err.response.status === 422) {
                        setError(err.response.data.errors);
                    }
                    if (err.response.status === 401) {
                        localStorage.removeItem('token');
                    }
                } else {
                    message.error('Backend not yet Started');
                }
                setLoading(false);
            });
    };

    const handleChangeDetailsTable = (pagination, filter, sorter) => {
        setPageDetail(pagination.current);
        setPerPageDetail(pagination.pageSize);

        setSortDetail({
            sort: sorter.field,
            order: sorter.order,
        });
    };

    const handleChangeDetails = (data) => {
        const index = data[data.length - 1];
        console.log(index);
        setRowDetails([index]);
        if (index) {
            const data2 = index.split(';');
            console.log('master ng detail', data2);
            setSelectedId(data2[0]);
            getSpCardDetail(data2[0]);
        }
    };

    const getSpCardDetail = (id = selectedId) => {
        setLoadingDetail(true);
        axios
            .get(`${url}/master-ng/details/${id}`, {
                params: {
                    keyword: keywordDetails,
                    perpage: perPageDetail,
                    page: pageDetail,
                    sort: sortDetail.sort,
                    order: sortDetail.order,
                },

                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then((res) => {
                setSpCardDetail(res.data.data);
                setTotalDetail(res.data.total);
            })
            .catch((err) => {
                if (err.response) {
                    message.error(err.response.data.message);
                } else {
                    message.error('Backend not yet Started');
                }
            })
            .finally(() => {
                setLoadingDetail(false);
            });
    };

    const getMasterDetail = () => {
        const columns = [
            {
                title: 'Id',
                dataIndex: '_id',
                align: 'center',
                key: '_id',
                render: (data, record, index) => {
                    return (pageDetail - 1) * perPageDetail + index + 1;
                },
            },
            {
                title: 'Ng Parent Name',
                dataIndex: 'name',
                align: 'center',
                key: 'name',
                render: (id, data) => {
                    const parentName = data.tbm_ng_header?.name;
                    return <>{parentName}</>;
                },
            },
            {
                title: 'Ng Child Name',
                dataIndex: 'ng_name',
                align: 'center',
                key: 'ng_name',
            },
        ];

        return (
            <>
                <Row>
                    <Col xs={24}>
                        {/* <RangePicker
                  onChange={handleChangeDate}
                  value={[date.from, date.to]}
                  format="DD MMM YYYY"
                  picker="date"
                  // style={{ marginBottom: "2%" }}
                /> */}

                        <Table
                            //scroll={{ x: 1000 }}
                            columns={columns}
                            rowKey={(data) => data._id}
                            pagination={{
                                pageSize: perPageDetail,
                                current: pageDetail,
                                total: totalDetail,
                                showSizeChanger: true,
                                style: {
                                    marginTop: '2rem',
                                    marginBottom: 0,
                                },
                            }}
                            loading={loadingDetail}
                            dataSource={spCardDetail}
                            // size="small"
                            onChange={handleChangeDetailsTable}
                        />
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <div>
            <ul className="breadcumb">
                <li className="active">Master Ng</li>
            </ul>
            <div className="content">
                <Row justify="space-between">
                    <Col>
                        <Can accessTo="Create NG">
                            <Link to="/master-ng/create">
                                <Button
                                    type="primary"
                                    style={{
                                        backgroundColor: '#1b2086',
                                        borderColor: '#1b2086',
                                    }}
                                >
                                    <PlusOutlined />
                                    Add
                                </Button>
                            </Link>
                        </Can>

                        <Modal
                            title="Import Master Ng"
                            visible={isModalVisible}
                            footer={null}
                            u
                            onCancel={closeModal}
                        >
                            <Card className="body-data">
                                <div name="control-hooks">
                                    <div name="file" label="File">
                                        <Fragment>
                                            <Upload
                                                onRemove={handleRemove}
                                                beforeUpload={
                                                    handleBeforeUpload
                                                }
                                                fileList={[]}
                                            >
                                                <Button
                                                    style={{ marginBottom: 10 }}
                                                >
                                                    Choose File{' '}
                                                    <ExportOutlined />
                                                </Button>
                                            </Upload>
                                            {data.file && (
                                                <React.Fragment
                                                    children={[
                                                        <Button
                                                            onClick={
                                                                handleRemove
                                                            }
                                                            type="danger"
                                                            ghost
                                                        >
                                                            <DeleteOutlined />
                                                        </Button>,
                                                    ]}
                                                >
                                                    {data.file.name
                                                        ? data.file.name
                                                        : data.file}
                                                </React.Fragment>
                                            )}
                                        </Fragment>
                                    </div>
                                    <div>
                                        <Button
                                            loading={loading}
                                            onClick={onSaveData}
                                            type="primary"
                                            htmlType="submit"
                                            className="mr-button"
                                            style={{
                                                marginRight: 10,
                                                backgroundColor: '#1b2086',
                                                borderColor: '#1b2086',
                                            }}
                                        >
                                            Upload
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            onClick={handleRemove}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </Modal>
                        <Can accessTo="Import NG">
                            <Button
                                onClick={showModal}
                                type="primary"
                                style={{
                                    backgroundColor: '#1b2086',
                                    borderColor: '#1b2086',
                                    marginLeft: 10,
                                }}
                            >
                                <ImportOutlined />
                                Import
                            </Button>
                        </Can>
                        <Can accessTo="Export NG">
                            <Button
                                onClick={downloadTemplate}
                                type="primary"
                                style={{
                                    backgroundColor: '#1b2086',
                                    borderColor: '#1b2086',
                                    marginLeft: 10,
                                }}
                            >
                                <ExportOutlined />
                                Export
                            </Button>
                        </Can>
                    </Col>
                    <Col>
                        <Input.Search
                            allowClear="true"
                            onSearch={(value) => {
                                setPage(1);
                                setKeyword(value);
                            }}
                            placeholder="Search..."
                        />
                    </Col>
                </Row>
                <Row className="mt-40">
                    <Col xs={24}>
                        <Table
                            columns={columns}
                            dataSource={operator.data}
                            pagination={{
                                pageSize: perpage,
                                current: page,
                                total: total,
                                showSizeChanger: true,
                            }}
                            loading={loading}
                            expandable={{
                                expandedRowRender: getMasterDetail,
                                onExpandedRowsChange: (data) =>
                                    handleChangeDetails(data),
                                expandedRowKeys: rowDetails,
                            }}
                            rowKey={(data) => data._id}
                            onChange={handleTableChange}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Ng;
